import Avatar from 'antd/lib/avatar/avatar';
import * as React from 'react';
import { UserOutlined } from '@ant-design/icons';

interface UserAvatarProps {
    imageUrl?: string;
    size?: number;
}

const UserAvatar: React.FC<UserAvatarProps> = (props: UserAvatarProps) => {
    return <Avatar size={props.size ?? 48} src={props.imageUrl} icon={<UserOutlined />} />;
};

export default UserAvatar;
